// Conservative Shaka tuning: prefer stability over aggressive jumping.
export const shakaPlayerConfig = {
    streaming: {
        jumpLargeGaps: true,
        gapDetectionThreshold: 0.5,
        smallGapLimit: 0.5,
        stallEnabled: true,
        stallThreshold: 1.5,
        stallSkip: 0.05,
        safeSeekOffset: 5,
    },
};
